<script setup>
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const { t } = useI18n()
const router = useRouter()

function goToSupportRequests() {
  router.push({ name: 'my-support-requests' })
}
</script>

<template>
  <div class="flex items-center">
    <Button
      v-tooltip.bottom="t('core.header.tooltips.my-support-requests')"
      icon="pi pi-headphones"
      class="w-11! h-11! p-0! bg-dss-surface-200 hover:bg-dss-surface-250 transition-colors duration-200 rounded-2xl border-0 focus:outline-none focus:ring-0 transform-gpu will-change-transform text-dss-secondary-500"
      :aria-label="t('core.header.tooltips.my-support-requests')"
      data-testid="support-requests-header-button"
      @click="goToSupportRequests"
    />
  </div>
</template>
